<script lang="ts">
export default {
  name: "MainFobizzNavbarLoginDropdown",
};
</script>

<script setup lang="ts">
const { t } = useI18n();
</script>

<template>
  <li class="nav-item dropdown d-none d-lg-block login-dropdown">
    <a
      id="navbarLoginDropdown"
      class="main-fobizz-navbar__link login-dropdown__link"
      href="#"
      role="button"
      data-bs-toggle="dropdown"
      aria-expanded="false"
      aria-haspopup="true"
      data-testid="login-dropdown"
    >
      {{ t("mainFobizzNavbar.login") }}
      <BaseIcon icon-name="chevron-down" class="ms-1" />
    </a>
    <ul
      class="dropdown-menu dropdown-menu-end"
      style="width: 465px"
      aria-labelledby="navbarLoginDropdown"
    >
      <li>
        <router-link
          :to="{ name: 'login' }"
          class="dropdown-item login-dropdown__item-link"
        >
          <h6>{{ t("mainFobizzNavbar.teacherLogin.title") }}</h6>

          <p class="dropdown-item__description">
            {{ t("mainFobizzNavbar.teacherLogin.text") }}
          </p>
        </router-link>
      </li>
      <li>
        <router-link
          :to="{ name: 'go-login' }"
          class="dropdown-item login-dropdown__item-link"
        >
          <h6>
            {{ t("mainFobizzNavbar.pupilLogin.title") }}
          </h6>
          <p class="dropdown-item__description">
            {{ t("mainFobizzNavbar.pupilLogin.text") }}
          </p>
        </router-link>
      </li>
    </ul>
  </li>
</template>

<style scoped lang="scss">
.login-dropdown {
  &__item-link {
    display: block;

    &:focus,
    &:hover,
    &:active,
    &.active {
      color: $body-color;
      background-color: $color-gray-200;
    }
  }

  // Ugly overwrites to be aligned with platform
  // TODO: add better class names and styles
  .dropdown-item__description {
    font-size: $font-size-sm;
    font-weight: 400;
    white-space: normal;
    color: $secondary;
  }
}
</style>
